import React__default from 'react';
import { hasMark } from '../utilities/nodes/marks/hasMark.mjs';

/**
 * Get a `renderLeaf` handler for a single type.
 */
function getRenderLeaf({
  type,
  component: Component,
  rootProps
}) {
  return function renderLeaf({
    children,
    leaf
  }) {
    if (leaf.text && hasMark(leaf, type)) {
      return /*#__PURE__*/React__default.createElement(Component, Object.assign({
        leaf: leaf
      }, rootProps), children);
    }
    return children;
  };
}

export { getRenderLeaf };
